import { render, staticRenderFns } from "./MentionStatsSummary.vue?vue&type=template&id=22c69654"
import script from "./MentionStatsSummary.vue?vue&type=script&lang=js"
export * from "./MentionStatsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports